// src/components/RaportONasPage.jsx

import React from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

// Reuse your layout primitives from RaportyComponent
import {
  RaportWrapper,
  Content,
  PageBody,
  Card,
} from "./api/RaportyComponentStyles";

import { RaportONasInner } from "./RaportONas";

const RaportONasPage = () => {
  return (
    <RaportWrapper>
      <Sidebar />

      <Content>
        {/* Fixed top bar like the rest of the app */}
        <TopBar />

        {/* Scrollable content area */}
        <PageBody>
          <Card>
            <h2 style={{ marginBottom: 20 }}>Raport o nas</h2>
            <RaportONasInner />
          </Card>
        </PageBody>
      </Content>
    </RaportWrapper>
  );
};

export default RaportONasPage;
